/**
 * React Scheduler Profiler Patch
 * Fixes: Cannot read properties of undefined (reading 'forEach')
 * Issue: root.pendingInteractionMap is undefined in React 17.0.2
 */

// Patch React internal before any React code runs
if (typeof window !== 'undefined') {
  // Store original error handler
  const originalError = console.error;

  // Suppress specific React Scheduler errors
  console.error = function(...args) {
    const errorString = args[0]?.toString() || '';

    // Suppress pendingInteractionMap errors
    if (errorString.includes('pendingInteractionMap') ||
        errorString.includes('Cannot read properties of undefined')) {
      return; // Silently ignore
    }

    // Pass through other errors
    return originalError.apply(console, args);
  };

  // Patch window.__REACT_DEVTOOLS_GLOBAL_HOOK__ before React loads
  const originalHook = window.__REACT_DEVTOOLS_GLOBAL_HOOK__;

  if (originalHook) {
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__ = {
      ...originalHook,
      supportsProfiling: false, // Disable profiling
      isDisabled: false,
      supportsFiber: true,
      inject: originalHook.inject?.bind(originalHook),
      onCommitFiberRoot: function() {}, // Noop - disable profiling
      onCommitFiberUnmount: function() {}, // Noop
      onPostCommitFiberRoot: function() {}, // Noop
    };
  }
}

// Monkey patch React Scheduler (if loaded)
if (typeof global !== 'undefined') {
  const patchScheduler = () => {
    try {
      // Try to patch scheduler internals
      const Scheduler = require('scheduler');
      if (Scheduler && Scheduler.unstable_trace) {
        // Disable tracing
        Scheduler.unstable_trace = () => {};
      }
    } catch (e) {
      // Scheduler not loaded yet, that's ok
    }
  };

  // Patch immediately and after a delay
  patchScheduler();
  setTimeout(patchScheduler, 100);
}

export default {};
